import FullActivationModal from './FullActivationModal'
export default FullActivationModal
